<div class="text-right p-2">
    <ng-container *ngIf="controlTemplate?.settings?.value; else noValue">
        {{ controlTemplate?.settings?.value }}
    </ng-container>
    <ng-template #noValue>
        -
    </ng-template>
</div>